import { Flex } from "@radix-ui/themes";
import Footer from "@/components/nav/Footer";
import SmoothScroll from "@/components/ui/SmoothScroll";
import HeroSection from "@/components/fans/HeroSection";
import FeaturedAlbumsSection from "@/components/fans/FeaturedAlbumsSection";
import FeatureCardsSection from "@/components/fans/FeatureCardsSection";
import JoinLutelySection from "@/components/landing/JoinLutelySection";

// The fans page: /fans, and / for signed-in users.
export default function FansHome() {
  return (
    <Flex direction="column" className="bg-[#fafbfd]">
      <SmoothScroll />
      <HeroSection />
      <FeaturedAlbumsSection />
      <FeatureCardsSection />
      <JoinLutelySection />
      <Footer />
    </Flex>
  );
}
